export default "__VITE_ASSET__BVvys5Fs__"